var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopChevronArrowRoundOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M256 512c70.68 0 134.7-28.66 181.02-74.98C483.34 390.7 512 326.69 512 256c0-70.69-28.66-134.7-74.98-181.02C390.7 28.66 326.69 0 256 0 185.31 0 121.3 28.66 74.98 74.98 28.66 121.3 0 185.31 0 256c0 70.69 28.66 134.7 74.98 181.02C121.3 483.34 185.31 512 256 512zM146.96 284.09 256 175.06l109.04 109.03-40.51 40.52-68.52-68.51-68.52 68.52-40.53-40.53zm264.03 126.9c-39.66 39.66-94.47 64.2-154.99 64.2-60.53 0-115.33-24.54-154.99-64.2-39.66-39.66-64.2-94.46-64.2-154.99 0-60.53 24.54-115.33 64.2-154.99 39.66-39.66 94.46-64.2 154.99-64.2 60.53 0 115.33 24.54 154.99 64.2 39.66 39.66 64.2 94.46 64.2 154.99 0 60.53-24.54 115.33-64.2 154.99z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopChevronArrowRoundOutlineIcon);
export default __webpack_public_path__ + "static/media/top-chevron-arrow-round-outline-icon.b1cd13abd8f88b9b63b2d20c2d770279.svg";
export { ForwardRef as ReactComponent };